// Configurable tooltip copy — replace freely, no code changes elsewhere required.
export const DURCHLAUFZEIT_TIMELINE_INFO_TEXT =
  "Diese Kachel zeigt die Durchlaufzeit in Tagen zwischen einem Start- und einem End-Ereignis " +
  "im Zeitverlauf. Pro Tag fließen zwei Gruppen ein: aktuell noch laufende Objekte, die das " +
  "Start-Ereignis bereits erreicht, das End-Ereignis aber noch nicht erreicht haben (mit " +
  "ihrer bisherigen Dauer bis heute), sowie an diesem Tag abgeschlossene Objekte (mit ihrer " +
  "finalen Durchlaufzeit). Anders als bei Verspätungs-Kacheln gibt es hier keine " +
  "Pünktlich/Verspätet-Unterscheidung — es werden immer alle Objekte berücksichtigt. Da " +
  "einzelne Tage oft nur wenige Fälle haben, wird zusätzlich zur rohen Tageslinie eine " +
  "geglättete Linie über ein gleitendes Zeitfenster gezeigt — die Fallzahl dieses Fensters " +
  "steht im Tooltip des Diagramms.";
